import React from 'react';

const Background:React.FC = ()=>{
    return(<div className="bg-image"></div>);
};

export default Background;